/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'individual-performance': {
    width: 24,
    height: 24,
    viewBox: '0 0 1050 1024',
    data: '<path pid="0" d="M699.098 697.494l39.862-49.764a441.633 441.633 0 00-116.273-67.103A305.726 305.726 0 00794.335 305.71a305.77 305.77 0 10-460.418 263.867C152.028 624.611 19.606 793.581 19.606 993.488h63.747a378.992 378.992 0 01378.991-379.034c87.29 0 169.99 29.578 236.753 83.04zM246.457 305.71a242.065 242.065 0 11484.13 0 242.065 242.065 0 01-484.13 0z"/><path pid="1" d="M791.232 591.974l-10.964 62.768 138.286 24.096L680.06 829.151l-76.327-79.64-285.795 212.785 38.078 51.124 240.663-179.211 73.436 76.623 277.678-175.048L918.3 862.172l62.087 14.449 56.438-241.938z"/>'
  }
})
